import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import FindSpace from "./components/FindSpace";
import HowItWorks from "./components/HowItWorks";
import Benefits from "./components/Benefits";
import HomeLocation from "./components/HomeLocation";
import Testimonials from "./components/Testimonials";
import FAQAccordion from "@/components/feature/FAQAccordion";
import CTASection from "@/components/feature/CTASection";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function Home() {
  const { data } = useSiteData();
  const t = useT();
  const etiqueta = t("home.faq.etiqueta");
  const faqs = data.faqs.filter((f) => f.mostrar_en_inicio);

  return (
    <Layout>
      <Hero />
      <TrustBar />
      <FindSpace />
      <HowItWorks />
      <Benefits />
      <HomeLocation />
      <Testimonials />

      {faqs.length > 0 && (
        <section className="bg-background-100">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
            <div className="max-w-3xl mx-auto">
              <div className="text-center">
                {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
                <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
                  {t("home.faq.titulo")}
                </h2>
              </div>
              <div className="mt-8">
                <FAQAccordion items={faqs} />
              </div>
              <div className="mt-6 text-center">
                <Link
                  to="/preguntas-frecuentes"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition"
                >
                  {t("home.faq.ver_todas")} <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}

      <CTASection />
    </Layout>
  );
}